// This file contains the global pass through options for the PrimeVue components.

export const DataTable = {
  root: {
    class: "",
  },
  table: {
    class: "!border !border-t-0 !border-b-0 !border-surface-100",
    style: "width: 100%;",
  },
  header: {
    class:
      "!px-3.5 !py-2.5 !bg-surface-0 !border !border-surface-100 !rounded-t-lg",
  },
  headercell: {
    class: "!bg-surface-500",
  },
  bodycell: {
    class: "!bg-surface-0 !border-surface-100",
  },
  rowExpansionCell: {
    class: "!border-none !p-0",
  },
  tablecontainer: {
    class: "",
  },
  paginator: {
    class: "!hidden",
  },
  pcpaginator: {
    root: "!hidden",
  },
};

export const Column = {
  headerCell: {
    class:
      "!bg-surface-50 !border-surface-100 !text-surface-500 !text-sm !font-semibold !px-[14px] !py-[4px] !h-[24px]",
  },
  bodyCell: {
    class:
      "!bg-surface-0 !border-surface-100 !text-surface-950 text-sm !p-[14px]",
  },
};

export const Paginator = {
  root: {
    class: "!bg-surface-0",
  },
  current: "mx-8 !text-sm",
  contentStart: {
    class: "flex !justify-end !mr-0 !text-sm",
    style: "margin-inline-start: auto;",
  },
};

export const MultiSelect = {
  root: {
    class:
      "max-w-content text-sm !flex-row-reverse !shadow-none !bg-surface-0 !border-surface-200 min-h-[2.1rem]",
  },
  pcHeaderCheckbox: { class: "hidden" },
  pcFilter: {
    root: {
      class:
        "!text-sm !text-surface-600 !bg-surface-100 !border-surface-200 !shadow-none",
    },
  },
  dropdown: { class: "!w-[0.75rem] !pl-[1rem] !mr-[0.5rem]" },
  dropdownicon: { class: "!text-sm !text-surface-600" },
  label: {
    class: "!pl-[0.5rem] !pr-[0.65625rem] !py-1.5 !text-sm !text-surface-600",
  },
  labelcontainer: { class: "flex justify-center items-center" },
  overlay: {
    class: "!bg-surface-0 !text-sm !border-surface-200",
  },
  header: {
    class: "!px-2",
  },
  headerPcFilter: {
    class: "!text-sm !text-surface-600",
  },
  option: {
    class: `!text-sm !focus:!ring-0 !focus:!outline-none 
    !text-surface-600 !hover:!bg-surface-100 !selected:!bg-surface-100 [&.p-focus]:!bg-surface-100
    `,
  },
};
export const ClassicMultiSelect = {
  root: {
    class: "!bg-surface-0 !border-surface-200 !text-surface-600",
  },
  pcHeaderCheckbox: { class: "hidden" },
  pcFilter: {
    root: {
      class:
        "!text-sm !text-surface-600 !bg-surface-100 !border-surface-200 !shadow-none",
    },
  },
  dropdown: { class: "" },
  dropdownicon: { class: "" },
  label: {
    class: "!text-surface-600",
  },
  labelcontainer: { class: "flex items-center" },
  overlay: {
    class: "!bg-surface-0 !text-sm !border-surface-200",
  },
  header: {
    class: "!px-2",
  },
  headerPcFilter: {
    class: "!text-sm !text-surface-600",
  },
  option: {
    class: `!text-sm !focus:!ring-0 !focus:!outline-none 
    !text-surface-600 !hover:!bg-surface-100 !selected:!bg-surface-100 [&.p-focus]:!bg-surface-100
    `,
  },
};

export const Select = {
  root: {
    class: "!text-xs !bg-surface-0 !border-surface-200",
  },
  label: {
    class: "text-surface-900 !flex !items-center !text-sm",
    style: {
      "--p-select-color": "var(--p-surface-600)",
    },
  },
  overlay: {
    class: " !bg-surface-0 !text-xs !border-surface-200",
  },
  option: {
    class: "!text-sm !text-surface-600 hover:!bg-surface-100",
    style: {
      "--p-select-option-selected-background": "var(--p-surface-100)",
      "--p-select-option-selected-focus-background": "var(--p-surface-100)",
      "--p-select-option-focus-background": "var(--p-surface-100)",
    },
  },
  list: {
    class: "!text-xs !text-surface-600",
  },
  pcFilter: {
    root: "!text-xs !text-surface-600",
  },
  header: {
    class: "text-xs",
  },
  select: {
    class:
      "!text-sm !text-surface-600 !bg-surface-100 !border-surface-200 !shadow-none !disabled:!bg-transparent !bg-transparent",
  },
};

export const Popover = {
  root: {
    class: `
      !p-3
      !bg-surface-0
      !border-surface-200
      !bg-surface-0
      !text-surface-600
      before:!content-none before:!block before:!hidden after:!content-none after:!block after:!hidden
      !tex-xs
      `,
  },
  content: {
    class: `
      !p-0
      `,
  },
};

export const ToggleButton = {
  root: {
    class: `
      !bg-surface-100
      !border-surface-100
    `,
  },
  content: {
    class: `
      !shadow-none [&[data-p="checked"]]:!bg-surface-300
    `,
  },
};

export const Tag = {
  root: {
    class: `
      !px-[0.438rem] !py-[0.219rem] !text-sm !font-bold

      data-[p~="success"]:!bg-green-100 data-[p~="success"]:!text-green-700
      dark:data-[p~="success"]:!bg-[#062010] dark:data-[p~="success"]:!text-green-300

      data-[p~="warn"]:!bg-orange-100 data-[p~="warn"]:!text-orange-700
      dark:data-[p~="warn"]:!bg-[#281203] dark:data-[p~="warn"]:!text-orange-300

      data-[p~="danger"]:!bg-red-100 data-[p~="danger"]:!text-red-700
      dark:data-[p~="danger"]:!bg-[#270b0c] dark:data-[p~="danger"]:!text-red-300

      dark:data-[p~="primary"]:!bg-primary dark:data-[p~="primary"]:!text-surface-0
    `,
    style: {
      "--p-tag-primary-background": "#D3DCF6",
      "--p-tag-primary-color": "var(--p-primary-color)",
      "--p-tag-secondary-background": "var(--p-surface-100)",
      "--p-tag-secondary-color": "var(--p-surface-700)",
    },
  },
  label: {
    class: `
      !text-xs
      `,
  },
};

export const AutoComplete = {
  optionGroup: {
    class: "!bg-surface-100 !text-surface-950 text-sm",
  },
  list: {
    class: "px-0 pt-0",
  },
  root: {
    class:
      "max-w-content text-sm !flex-row-reverse !shadow-none !bg-surface-0 !border-surface-200 min-h-[2.1rem]",
  },
  pcHeaderCheckbox: { class: "hidden" },
  pcFilter: {
    root: {
      class:
        "!text-sm !text-surface-600 !bg-surface-100 !border-surface-200 !shadow-none",
    },
  },
  dropdown: { class: "!w-[0.75rem] !pl-[1rem] !mr-[0.5rem]" },
  dropdownicon: { class: "!text-sm !text-surface-600" },
  label: {
    class: "!pl-[0.5rem] !pr-[0.65625rem] !py-1.5 !text-sm !text-surface-600",
  },
  labelcontainer: { class: "flex justify-center items-center" },
  overlay: {
    class: "!bg-surface-0 !text-sm !border-surface-200",
  },
  header: {
    class: "!px-2",
  },
  headerPcFilter: {
    class: "!text-sm !text-surface-600",
  },
  option: {
    class: `!text-sm !focus:!ring-0 !focus:!outline-none 
    !text-surface-600 !hover:!bg-surface-100 !selected:!bg-surface-100 [&.p-focus]:!bg-surface-100
    `,
  },
};

export const Dialog = {
  root: {
    class: "!bg-surface-0 !text-surface-600",
    style: {
      "--p-dialog-border-color": "var(--p-surface-200)",
      "--p-confirmdialog-icon-color": "var(--p-surface-950)",
    },
  },
  pcCloseButton: {
    root: "hover:!bg-transparent",
  },
};

export const DatePicker = {
  root: {
    class: "!p-0",
    style:
      "--p-datepicker-date-range-selected-background: var(--p-primary-700);",
  },
  inputIcon: {
    class: "!text-surface-600",
  },
  pcInputText: {
    root: {
      class:
        "!border-surface-200 !bg-surface-0 !py-0 !px-2.5 !shadow-none !text-sm !text-surface-600 w-full",
    },
  },
  panel: {
    class: "!bg-surface-0 !border-surface-200",
  },
  header: {
    class: "!bg-surface-0 !border-surface-200",
  },
  decade: {
    class: "!text-surface-950",
  },
  selectyear: {
    class: "!text-surface-950 hover:!text-surface-50",
  },
  selectmonth: {
    class: "!text-surface-950 hover:!text-surface-50",
  },
  year: {
    class: "!text-surface-950 hover:!text-surface-50",
  },
  month: {
    class: "!text-surface-950 hover:!text-surface-50",
  },
  day: {
    class: `
      !text-surface-900 hover:!bg-surface-100 hover:!text-surface-900 data-[p="today"]:!bg-surface-100
      `,
  },
  weekday: {
    class: "flex justify-center !text-surface-950",
  },
};

// Accordion with table content
export const AccordionPassThrough = {
  root: {
    class: `
      border !border-surface-200 !rounded-xl 
    `,
  },
};

export const AccordionPanelPassThrough = {
  root: {
    class: `
      data-[p-active="true"]:!border-b-0
      last:!border-b-0 
    `,
  },
};

export const AccordionHeaderPassThrough = {
  root: {
    class: `
        !px-3.5 !py-2.5 !rounded-t-xl
        !bg-surface-0 !border-surface-200
      `,
  },
  toggleicon: {
    class: `
      !hidden
    `,
  },
};

export const AccordionContentPassThrough = {
  content: {
    class: `
      !p-0 !rounded-b-xl
      !bg-surface-0 !border-surface-200
    `,
  },
};

export const Textarea = {
  root: {
    class: "!bg-surface-0 !border-surface-200 !text-surface-950 !shadow-none",
  },
};

export const Checkbox = {
  box: {
    class:
      "!bg-surface-100 !border-surface-200 !text-surface-950 hover:!text-surface-950 !shadow-none",
    style:
      "--p-checkbox-icon-checked-color: var(--p-surface-950); --p-checkbox-icon-checked-hover-color: var(--p-surface-500);",
  },
};

export const Drawer = {
  root: {
    class: "!bg-surface-0 !border-surface-200 !text-surface-600",
  },
  title: {
    class: "!text-surface-900",
  },
  pcCloseButton: {
    root: "hover:!bg-transparent",
  },
};

export const TreeTable = {
  header: {
    class:
      "!border !rounded-t-lg !px-3.5 !py-2 !border-surface-100 !bg-surface-0",
  },
  table: {
    class: "!border-surface-100 border-l border-b",
  },
  emptymessagecell: {
    class: "!bg-surface-0 !border-surface-100",
  },
};

// ===============================================
// Component specific pass through options
// ===============================================

// ================================
// InputText
// ================================

export const InputText = {
  root: {
    class:
      "!bg-surface-0 !border-surface-200 !text-surface-950 !shadow-none !text-sm",
  },
};

// TransparentInputText
export const TransparentInputText = {
  root: {
    // dark:text-surface-950
    class: `
      w-[40px] p-0 bg-transparent text-center
      text-surface-700 !text-sm
      border-none border-transparent rounded-none shadow-none focus:border-transparent focus:ring-0 focus:outline-none
      `,
  },
};

// ================================
// Button
// ================================

// Primary
// TODO: Add hover state
export const ButtonPrimary = {
  root: {
    class: `
      !py-[0.438rem] !px-[0.969rem] 
      !text-sm !font-medium 
      !bg-primary-500 
      !border-primary-600
      hover:!bg-primary-400
    `,
  },
};

// Outlined
export const ButtonOutlined = {
  root: {
    class: `
      !py-[0.438rem] !px-[0.969rem] 
      !text-sm !font-medium 
      !border-surface-200
      !text-surface-600
      hover:!bg-transparent
    `,
  },
};

// Outlined
export const ButtonSecondary = {
  root: {
    class: `
      !py-[0.438rem] !px-[0.969rem] 
      !text-sm !font-medium 
      !text-surface-600
      hover:!bg-surface-200
    `,
  },
};

// Outlined
export const ButtonRounded = {
  root: {
    class: `
      !py-[0.438rem] !px-[0.969rem] 
      !text-sm !font-medium 
      !border-surface-200
      !text-surface-600
      hover:!bg-transparent
    `,
  },
};

export const MenuPt = {
  root: {
    class: "!border-surface-200 !bg-surface-0",
  },
  list: {
    class: "!bg-surface-0 !border-surface-200 !rounded-md",
  },
  itemContent: {
    class: "!bg-surface-0 hover:!bg-surface-200 !text-sm",
  },
  item: {
    class:
      "!bg-surface-0 hover:!bg-surface-200 focus:!bg-surface-200 selected:!bg-surface-200 !rounded-sm !text-surface-600",
  },
  itemIcon: {
    class: "!text-surface-600",
  },
  itemLabel: {
    class: "!text-surface-600",
  },
  itemLink: {
    class: "!text-surface-600",
  },
  menu: {
    class: "!border-surface-200 !bg-surface-0",
  },
};

export const TabPanel = {
  root: {
    class: "!bg-surface-0 !text-surface-600",
  },
};

export const TabPanels = {
  root: {
    class: "!bg-surface-0 !text-surface-600",
  },
};

export const Tab = {
  root: {
    class: "!bg-surface-0 !text-surface-600",
  },
};

export const TabList = {
  root: {
    class: "!bg-surface-0 !text-surface-600",
  },
  content: {
    class: "!bg-surface-0 !text-surface-600",
  },
  tablist: {
    class: "!bg-surface-0 !text-surface-600",
  },
};

export const MeterGroup = {
  root: {
    style: {
      "--p-metergroup-meters-background": "var(--p-surface-200)",
    },
  },
};

export const ToggleSwitch = {
  root: {
    style: {
      "--p-toggleswitch-background": "var(--p-surface-200)",
    },
  },
};

export const DualToggleSwitch = {
  root: {
    style: {
      "--p-toggleswitch-background": "var(--p-primary-500)",
      "--p-toggleswitch-hover-background": "var(--p-primary-500)",
    },
  },
};

export const Divider = {
  root: {
    style: {
      "--p-divider-border-color": "var(--p-surface-300)",
      "--p-divider-content-background": "var(--p-surface-0)",
      "--p-divider-content-color": "var(--p-surface-750)",
    },
  },
};

export const Toast = {
  messageicon: {
    class: "!mt-[3px]",
  },
};
